import { computed } from '@vue/composition-api';
import { DialogPlugin } from 'tdesign-vue';

import i18n, { i18n_t } from '@/locales/i18n';
import store from '@/renderer/store';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import upgradeDialog from '@/renderer/scripts/utils/upgradeDialog';
import { IS_OPEN_IN_APPLE } from '@/common/constant/platform';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

const { orgChannel, channelUpdated, editionFlag, orgId } = store.getters;

export const upgradeName = computed(() => {
  if (orgChannel && !channelUpdated && IS_OPEN_IN_APPLE) {
    return i18n_t('更多扩容方案');
  }
  return i18n_t('扩容');
});

export async function goUpgrade(type: string) {
  // 再检查一下后台返回的数据，然后再跳转
  await store.dispatch('GetOrgInfo', store.getters.orgId);
  const { orgChannel, channelUpdated, instanceId } = store.getters;
  let source = '';
  let header = '';
  let body = '';
  switch (type) {
    case 'user_number':
      reporter.report('value_added', {
        user_number_click: 'management_center_user_number_button',
      });
      source = 'user_stat_limit';
      header = i18n_t('当前套餐可用账号数量已达上限');
      body = i18n_t('升级企业版可自由增加存储空间容量，获取更优体验');
      break;
    case 'flow':
      reporter.report('value_added', {
        flow_click: 'management_center_flow_button',
      });
      break;
    case 'space':
      source = 'quota_limit';
      header = i18n_t('当前套餐可用账号数量已达上限');
      body = i18n_t('升级企业版可自由增加可用账号数量，获取更优体验');
      reporter.report('value_added', {
        space_click: 'management_center_value_button',
      });
      break;
    default:
      break;
  }
  if (editionFlag === 'enterprise') {
    if (store.getters.isPrivate) {
      const dialog = CustomDialog.confirm({
        header: i18n_t('提示'),
        body: i18n_t('请联系运维管理员进行扩容！'),
        closeBtn: false,
        // @ts-ignore
        cancelBtn: null,
        theme: 'info',
        onConfirm: () => {
          if (dialog.hide) {
            dialog.hide();
          }
        },
      });
    } else if (orgChannel && !channelUpdated) {
      dispatchRouter(`${CONSTANT_URL.channelBuyUrl}&orgId=${orgId}&instanceId=${instanceId}`);
    } else {
      // 企业版直接进控制台
      dispatchRouter(CONSTANT_URL.consoleManagementUrl);
    }
  } else {
    type !== 'flow' &&
      upgradeDialog.show({
        source,
        header,
        body,
      });
  }
}
